import { Serializable } from '@/models/core/serializable';

// 進級処理用リクエスト
export class StudentPromotionRequest implements Serializable<StudentPromotionRequest> {
  oldSchoolClassID: number;
  newSchoolClassID: number;

  deserialize(input: any): StudentPromotionRequest {
    this.oldSchoolClassID = input.oldSchoolClassID;
    this.newSchoolClassID = input.newSchoolClassID;
    return this;
  }
}
